import Privacy from './index.vue'

export default {
    path: '/privacy',
    name: 'privacy',
    component: Privacy,
    meta: { title: 'dashboard_v2.titles.privacy' },
}
